module.exports = __webpack_public_path__ + "static/img/publicar curso 1024x768.02eb8f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing/capacitador/publicar/publicar curso 1024x768.jpg
// module id = lAcy
// module chunks = 47